import * as React from 'react';

import { Container, LegacyContainerStatus } from 'types/Watchlist';

import { PortCollectionFeature } from 'types/Port';
import { useRegionContext } from 'common/contexts/RegionContext';
import { PickedUp } from './PickedUp';
import { Schedule, ScheduleUpdateIndicator } from './Schedule';
import { EmptyCell } from '../EmptyCell';
import { CellProps } from '../types';
import { Cell } from '../Cell';
import { displayTerminalPort } from '../utility';

export const PickupCell: React.FC<CellProps> = (props) => {
  const container: Container = props.row;
  const { status, pickupInfo, gatedOut } = container;
  const { availableRegions } = useRegionContext();

  const terminalName = gatedOut?.terminalName || pickupInfo?.terminalName;
  const portName = gatedOut?.portName || pickupInfo?.portName;
  const portCollectionCode =
    gatedOut?.portCollectionCode || container.pickupInfo?.portCollectionCode;
  const portRegion = portCollectionCode
    ? availableRegions.find((r) => r.code === portCollectionCode)
    : undefined;

  let inner: React.ReactNode = null;
  switch (status) {
    case LegacyContainerStatus.OnVessel:
    case LegacyContainerStatus.Import:
      inner = <Schedule container={container} />;
      break;
    case LegacyContainerStatus.GatedOut:
    case LegacyContainerStatus.Terminated:
      if (!gatedOut) {
        return <EmptyCell />;
      }
      inner = <PickedUp container={container} />;
      break;
    default:
      return <EmptyCell />;
  }
  return (
    <Cell className="space-y-1 flex flex-col items-center text-center">
      <h5>{displayTerminalPort(terminalName, portName)}</h5>
      {inner}
      {status === LegacyContainerStatus.Import &&
        portRegion?.features?.includes(PortCollectionFeature.AppointmentScraping) && (
          <ScheduleUpdateIndicator container={container} />
        )}
    </Cell>
  );
};
PickupCell.displayName = 'ContainerTable.PickupCell';
